import { AxiosInstance } from 'axios';
import { MeRepository } from '@/model/repository/manager/me/MeRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): MeRepository => ({
    index() {
      return Repository.get(`${resource}`);
    },
  });
